import Vue from "vue";
import axios from 'axios'

const apiClient = axios.create({
  baseURL: process.env.VUE_APP_API_URL_ORDER,  
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'X-Oc-Merchant-Id': process.env.VUE_APP_MERCHANT_ID
  },
  timeout: 60000
})

export default {
  async validateIccid(iccid) {
    return await apiClient.post('/validation/iccid',{
        iccid: iccid
    });
  },
  async recharge(msisdn, products) {
    Vue.$log.debug("recharge : ", msisdn);
    Vue.$log.debug("products : ", products);
    return await apiClient.post('/recharge',{
        msisdn: msisdn,
        products: products
    });
  },
  async sim(delivery, payment_details, promo_code, sims_data, user, password, add_charges) {    
    return await apiClient.post('/sim',{
        delivery_details: delivery,
        payment_details: payment_details,        
        promo_code: promo_code,        
        sims: sims_data,
        user: user,
        password: password,
        add_charges: add_charges
    });
  },
  async simOrder(delivery, payment_details, promo_code, sims_data, add_charges, credit_score, user_exists) {    
    return await apiClient.post('/simOrder',{
        delivery_details: delivery,
        payment_details: payment_details,        
        promo_code: promo_code,        
        sims: sims_data,
        add_charges: add_charges, 
        credit_score: credit_score,
        user: { exists: user_exists, email_address: sims_data[0].subscriber.email_address }
    });
  },
}